// translations.js
export const translations = {
  // ===================== NAVIGATION =====================
  navigation: {
    en: {
      home: "Home",
      about: "About", 
      writings: "Writings",
      media: "Media",
      subscribe: "Subscribe",
      contact: "Contact",
      tagline: "Building the infinite future"
    },
    es: {
      home: "Inicio",
      about: "Acerca de",
      writings: "Escritos", 
      media: "Medios",
      subscribe: "Suscribirse",
      contact: "Contacto",
      tagline: "Construyendo el futuro infinito"
    }
  },

  // ===================== HOME PAGE =====================
  home: {
    en: {
      // Hero Section
      future: "THE FUTURE WILL BE",
      chips: ['SUSTAINABLE', 'INTELLIGENT', 'INFINITE'],
      byDesign: "BY DESIGN",
      founder: "Building at the intersection of real estate, venture, and sustainability.",
      intersection: "",
      learnMore: "Learn More",

      // Intro Section
      introHeading: "I'm Zeus Hernandez — founder of Infinity Development and host of Infinity Podcast.",
      introDescription: "I work across real estate, venture, and sustainability, focused on how we design, finance, and scale the built world. This is my digital studio: a place for ideas, field notes, and long-term thinking.",
      learnMoreInfinity: "Learn More About Infinity Development",
      infinityTagline: "Commercial real estate investment and development firm focused on sustainability, performance, and long-term value creation.",

      // Videos Section
      videosEyebrow: "Quick Takes and Visual Explainers",
      videosTitle: "Shorts & Videos",
      videosDescription: "Field notes and insights from the front lines of modern real estate and development.",
      watchAllVideos: "Watch All Videos",

      // Cards Section
      cardsEyebrow: "Explore My Work",
      cardsTitle: "Digital Studio",
      cardsDescription: "Conversations, research, and visual work exploring the future of the built environment.",
      
      podcastTitle: "The Infinity Podcast",
      podcastDescription: "Conversations with builders, investors, and visionaries shaping what's next.",
      podcastCta: "Listen Now",

      writingsTitle: "Writings",
      writingsDescription: "Frameworks, essays, and strategies on cities, capital, and design.",
      writingsCta: "Read More",

      videosCardTitle: "Shorts & Videos", 
      videosCardDescription: "Short insights and visual explainers from the field.",
      videosCardCta: "Watch Now",

      newsletterCardTitle: "Newsletter",
      newsletterCardDescription: "Weekly perspectives on real estate, venture, and the future of building.",
      newsletterCardCta: "Subscribe",

      // Newsletter CTA Section
      newsletterEyebrow: "Stay Connected",
      newsletterTitle: "Subscribe to Newsletter", 
      newsletterSubtitle: "A weekly letter on Real Estate, Venture, and Legacy.",
      emailPlaceholder: "Enter your email",
      subscribeButton: "Subscribe",

      videoThumbLabel: "Video Thumbnail",
    videoThumbSub:    (title) => title,

      videosList: [
      { id: 1, title: "Building the Future, One Idea at a Time", description: "Conversations and insights shaping how we design, finance, and build tomorrow’s world.", thumbnail: "video-thumb-1.jpg", duration: "2:15" },
      { id: 2, title: "AI in Construction", description: "How intelligence transforms building", thumbnail: "video-thumb-2.jpg", duration: "1:45" },
      { id: 3, title: "Sustainable Cities", description: "Field notes from innovative projects", thumbnail: "video-thumb-3.jpg", duration: "3:20" },
      { id: 4, title: "Capital Strategy", description: "Venture insights for developers", thumbnail: "video-thumb-4.jpg", duration: "2:30" },
      { id: 5, title: "Design Intelligence", description: "The intersection of tech and architecture", thumbnail: "video-thumb-5.jpg", duration: "2:05" }
    ]
    },
    es: {
      // Hero Section
      future: "EL FUTURO SERÁ",
      chips: ['SOSTENIBLE', 'INTELIGENTE', 'INFINITO'],
      byDesign: "POR DISEÑO",
      founder: "Construyendo en la intersección de bienes raíces, capital de riesgo y sostenibilidad.",
      intersection: "",
      learnMore: "Saber Más",

      // Intro Section
      introHeading: "Soy Zeus Hernández — fundador de Infinity Development y conductor de Infinity Podcast.",
      introDescription: "Trabajo en bienes raíces, capital de riesgo y sostenibilidad, enfocado en cómo diseñamos, financiamos y escalamos el mundo construido. Este es mi estudio digital: un lugar para ideas, notas de campo y pensamiento a largo plazo.",
      learnMoreInfinity: "Conoce Más Sobre Infinity Development",
      infinityTagline: "Firma de inversión y desarrollo de bienes raíces comerciales enfocada en sostenibilidad, rendimiento y creación de valor a largo plazo.",

      // Videos Section
      videosEyebrow: "Reflexiones Rápidas y Explicaciones Visuales",
      videosTitle: "Cortos y Videos",
      videosDescription: "Notas de campo e ideas desde las líneas del frente de los bienes raíces y el desarrollo moderno.",
      watchAllVideos: "Ver Todos los Videos",

      // Cards Section
      cardsEyebrow: "Explora Mi Trabajo",
      cardsTitle: "Estudio Digital",
      cardsDescription: "Conversaciones, investigación y trabajo visual explorando el futuro del entorno construido.",
      
      podcastTitle: "The Infinity Podcast",
      podcastDescription: "Conversaciones con constructores, inversionistas y visionarios que dan forma al futuro.",
      podcastCta: "Escuchar Ahora",

      writingsTitle: "Escritos",
      writingsDescription: "Marcos de trabajo, ensayos y estrategias sobre ciudades, capital y diseño.",
      writingsCta: "Leer Más",

      videosCardTitle: "Cortos y Videos",
      videosCardDescription: "Perspectivas breves y explicaciones visuales desde el campo.",
      videosCardCta: "Ver Ahora",

      newsletterCardTitle: "Newsletter",
      newsletterCardDescription: "Perspectivas semanales sobre bienes raíces, capital de riesgo y el futuro de la construcción.",
      newsletterCardCta: "Suscribirse",

      // Newsletter CTA Section
      newsletterEyebrow: "Mantente Conectado",
      newsletterTitle: "Suscríbete al Newsletter",
      newsletterSubtitle: "Una carta semanal sobre Bienes Raíces, Capital de Riesgo y Legado.",
      emailPlaceholder: "Ingresa tu email",
      subscribeButton: "Suscribirse",

      videoThumbLabel: "Miniatura del Video",
    videoThumbSub:    (title) => title,

      videosList: [
      { id: 1, title: "El Futuro de los Bienes Raíces", description: "Ideas rápidas sobre desarrollo regenerativo", thumbnail: "video-thumb-1.jpg", duration: "2:15" },
      { id: 2, title: "IA en la Construcción", description: "Cómo la inteligencia transforma la edificación", thumbnail: "video-thumb-2.jpg", duration: "1:45" },
      { id: 3, title: "Ciudades Sostenibles", description: "Notas de campo de proyectos innovadores", thumbnail: "video-thumb-3.jpg", duration: "3:20" },
      { id: 4, title: "Estrategia de Capital", description: "Perspectivas de venture para desarrolladores", thumbnail: "video-thumb-4.jpg", duration: "2:30" },
      { id: 5, title: "Inteligencia de Diseño", description: "La intersección de tecnología y arquitectura", thumbnail: "video-thumb-5.jpg", duration: "2:05" }
    ]
    }
  },

  // ===================== ABOUT PAGE =====================
  about: {
    en: {
      title: "To Infinity and Beyond",
      subtitle: "About Zeus Hernandez",

      bio: {
        title: "About Zeus Hernandez",
        subtitle: "Founder. Builder. Visionary.",
        content: "Zeus Hernandez is a real estate developer, platform builder, and long-horizon thinker focused on how cities, capital, and technology shape the future of society. He is the Founder & CEO of Infinity Development, a commercial real estate investment and development firm focused on sustainable multifamily and mixed-use projects across select markets in the United States and Latin America.\n\nEducated in real estate at UCLA, Zeus brings experience across construction, market analysis, capital strategy, and early-stage platform building. His work sits at the intersection of real assets, sustainability, and innovation - grounded in disciplined execution today, while designed for relevance decades into the future.\n\nHe is also the host of The Infinity Podcast, a bilingual platform featuring conversations with investors, developers, founders, and operators shaping the future of the built world, capital strategy, and long-term value creation. Zeus is currently authoring his first book on innovation in the built environment."
      },

      letter: {
        title: "A Letter from Zeus",
        paragraphs: [
          "I've always been obsessed with building - not just structures, but systems, ideas, and visions that last.",
          "Growing up in a family with immigrant roots made me entrepreneurial by nature and visionary by necessity. I learned early that nothing is guaranteed, that opportunity must be created, and that if you want to see a different future, you often have to build it yourself. That mindset shaped how I think about work, risk, and responsibility.",
          "To me, real estate is one of the most consequential industries in the world. It shapes economies, communities, and the daily lives of millions. It sits at the intersection of design, capital, technology, and human behavior. And today - with the rise of AI, sustainability, and global connectivity - we have a rare opportunity to rethink how the world is built.",
          "My ambition has never been limited to short-term wins. I'm interested in designing for generations - in creating environments, systems, and platforms that endure economically, socially, and environmentally.",
          "This site is my digital studio: a place to share ideas, field notes, conversations, and frameworks as I build - publicly, thoughtfully, and with intention."
        ]
      },

      definingMoment: {
        title: "A Defining Moment",
        paragraphs: [
          "Early in my journey, a single moment reshaped how I think about time, urgency, and purpose.",
          "After surviving a severe car crash outside Las Vegas, I was forced to confront a simple truth: time is not promised. In the aftermath, what stayed with me wasn't fear, it was clarity. Comfort disappeared. Hesitation no longer made sense.",
          "That experience didn't change what I wanted to build. It changed how seriously I took the responsibility to build it well.",
          "From that point forward, I committed fully to creating work that would outlast me - work rooted in conviction, discipline, and long-term impact. Infinity was born from that realization: that what we build should matter, endure, and serve something larger than ourselves."
        ]
      },

      buildingInfinity: {
        title: "Building Toward Infinity",
        paragraphs: [
          "Infinity Development is the foundation of my work, but not the endpoint.",
          "I am building toward a broader, long-term platform: Infinity. A multi-decade vision designed to operate across real assets, innovation, and impact-driven initiatives. Over time, this platform is intended to expand into areas such as venture investing, energy, ocean systems, and philanthropic work - each developed deliberately, with independent leadership, governance, and accountability.",
          "This is not about scale for its own sake. It is about stewardship: deploying capital, technology, and design in ways that create durable value across markets and generations.",
          "Infinity is being built patiently. Methodically. With institutional discipline.\nOne vertical at a time."
        ]
      },

      mission: {
        title: "My Mission",
        content: "My mission is to build and support systems that create lasting value - economically, socially, and environmentally.\n\nThrough real estate development, research, and storytelling, I aim to help people think longer-term, act with intention, and build work that endures beyond short-term outcomes. I believe we have a responsibility not just to consume and extract, but to design, restore, and contribute."
      },

      vision: {
        title: "My Vision",
        content: "I envision a future where our cities regenerate the planet, where capital is aligned with long-term human outcomes, and where technology amplifies - rather than replaces - our ability to build meaningfully.\n\nA future where development is intelligent, sustainable, and principled by design.\n\nMy work is focused on helping shape that future by uniting people, ideas, and resources across borders and generations, and by building platforms that stand the test of time."
      },

      closingThought: {
        title: "Closing Thought",
        paragraphs: [
          "I am early in the journey, but clear on the direction.",
          "I am building deliberately.\nI am thinking long-term.\nAnd I am inviting others who share that mindset to build alongside me."
        ]
      },

      volunteeringTitle: "Impact",
      portfolioTitle: "Learn More About Infinity Development",
      portfolioSubtitle: "Developing the next generation of sustainable projects.",

      visitInfinity: "Visit Infinity Development",
      learnMore: "Learn More",
      viewPortfolio: "View Portfolio"
    },
    es: {
      title: "Hacia el Infinito y Más Allá",
      subtitle: "Sobre Zeus Hernández",

      bio: {
        title: "Sobre Zeus Hernández",
        subtitle: "Fundador. Constructor. Visionario.",
        content: "Zeus Hernández es un desarrollador inmobiliario, constructor de plataformas y pensador de largo horizonte enfocado en cómo las ciudades, el capital y la tecnología moldean el futuro de la sociedad. Es el Fundador y CEO de Infinity Development, una firma de inversión y desarrollo de bienes raíces comerciales enfocada en proyectos sostenibles multifamiliares y de uso mixto en mercados selectos de Estados Unidos y América Latina.\n\nEducado en bienes raíces en UCLA, Zeus aporta experiencia en construcción, análisis de mercado, estrategia de capital y construcción de plataformas en etapa temprana. Su trabajo se encuentra en la intersección de activos reales, sostenibilidad e innovación, fundamentado en ejecución disciplinada hoy, mientras está diseñado para relevancia décadas en el futuro.\n\nTambién es el conductor de The Infinity Podcast, una plataforma bilingüe que presenta conversaciones con inversores, desarrolladores, fundadores y operadores que dan forma al futuro del mundo construido, estrategia de capital y creación de valor a largo plazo. Zeus está actualmente escribiendo su primer libro sobre innovación en el entorno construido."
      },

      letter: {
        title: "Una Carta de Zeus",
        paragraphs: [
          "Siempre he estado obsesionado con construir - no solo estructuras, sino sistemas, ideas y visiones que perduren.",
          "Crecer en una familia con raíces de inmigrantes me hizo emprendedor por naturaleza y visionario por necesidad. Aprendí temprano que nada está garantizado, que la oportunidad debe crearse, y que si quieres ver un futuro diferente, a menudo tienes que construirlo tú mismo. Esa mentalidad moldeó cómo pienso sobre el trabajo, el riesgo y la responsabilidad.",
          "Para mí, los bienes raíces son una de las industrias más consecuentes del mundo. Da forma a economías, comunidades y la vida diaria de millones. Se encuentra en la intersección del diseño, capital, tecnología y comportamiento humano. Y hoy - con el auge de la IA, sostenibilidad y conectividad global - tenemos una rara oportunidad de repensar cómo se construye el mundo.",
          "Mi ambición nunca se ha limitado a victorias a corto plazo. Estoy interesado en diseñar para generaciones - en crear entornos, sistemas y plataformas que perduren económica, social y ambientalmente.",
          "Este sitio es mi estudio digital: un lugar para compartir ideas, notas de campo, conversaciones y marcos mientras construyo - públicamente, reflexivamente y con intención."
        ]
      },

      definingMoment: {
        title: "Un Momento Definitorio",
        paragraphs: [
          "Temprano en mi camino, un solo momento reformó cómo pienso sobre el tiempo, urgencia y propósito.",
          "Después de sobrevivir a un grave accidente automovilístico afuera de Las Vegas, me vi obligado a confrontar una verdad simple: el tiempo no está prometido. En las consecuencias, lo que se quedó conmigo no fue miedo, fue claridad. La comodidad desapareció. La vacilación ya no tenía sentido.",
          "Esa experiencia no cambió lo que quería construir. Cambió cuán seriamente tomé la responsabilidad de construirlo bien.",
          "Desde ese punto en adelante, me comprometí completamente a crear trabajo que me sobreviviera - trabajo arraigado en convicción, disciplina e impacto a largo plazo. Infinity nació de esa realización: que lo que construimos debe importar, perdurar y servir algo más grande que nosotros mismos."
        ]
      },

      buildingInfinity: {
        title: "Construyendo Hacia el Infinito",
        paragraphs: [
          "Infinity Development es la fundación de mi trabajo, pero no el punto final.",
          "Estoy construyendo hacia una plataforma más amplia y de largo plazo: Infinity. Una visión multidécada diseñada para operar a través de activos reales, innovación e iniciativas impulsadas por impacto. Con el tiempo, esta plataforma está destinada a expandirse a áreas como inversión de riesgo, energía, sistemas oceánicos y trabajo filantrópico - cada uno desarrollado deliberadamente, con liderazgo, gobernanza y responsabilidad independientes.",
          "Esto no se trata de escala por el bien de la escala. Se trata de administración: desplegar capital, tecnología y diseño de maneras que creen valor duradero a través de mercados y generaciones.",
          "Infinity se está construyendo pacientemente. Metódicamente. Con disciplina institucional.\nUn vertical a la vez."
        ]
      },

      mission: {
        title: "Mi Misión",
        content: "Mi misión es construir y apoyar sistemas que creen valor duradero - económica, social y ambientalmente.\n\nA través del desarrollo inmobiliario, investigación y narración, mi objetivo es ayudar a las personas a pensar a más largo plazo, actuar con intención y construir trabajo que perdure más allá de resultados a corto plazo. Creo que tenemos una responsabilidad no solo de consumir y extraer, sino de diseñar, restaurar y contribuir."
      },

      vision: {
        title: "Mi Visión",
        content: "Visualizo un futuro donde nuestras ciudades regeneren el planeta, donde el capital esté alineado con resultados humanos a largo plazo, y donde la tecnología amplifique - en lugar de reemplazar - nuestra capacidad de construir significativamente.\n\nUn futuro donde el desarrollo sea inteligente, sostenible y con principios por diseño.\n\nMi trabajo está enfocado en ayudar a dar forma a ese futuro uniendo personas, ideas y recursos a través de fronteras y generaciones, y construyendo plataformas que resistan la prueba del tiempo."
      },

      closingThought: {
        title: "Pensamiento Final",
        paragraphs: [
          "Estoy temprano en el viaje, pero claro en la dirección.",
          "Estoy construyendo deliberadamente.\nEstoy pensando a largo plazo.\nY estoy invitando a otros que comparten esa mentalidad a construir junto a mí."
        ]
      },

      volunteeringTitle: "Impacto",
      portfolioTitle: "Conoce Más Sobre Infinity Development",
      portfolioSubtitle: "Desarrollando la próxima generación de proyectos sostenibles.",

      visitInfinity: "Visitar Infinity Development",
      learnMore: "Saber Más",
      viewPortfolio: "Ver Portafolio"
    }
  },

  media: {
  en: {
    hero: {
      badge: 'Media Hub',
      title: 'Media',
      subtitle:
        'Showcase of content in action. See and hear insights on real estate, venture, and sustainability.'
    },
    filters: {
      label: 'Filter:',
      all: 'All',
      podcast: 'Podcast',
      shorts: 'Shorts',
      longform: 'Long-form',
      articles: 'Articles'
    },
    podcast: {
      title: 'The Infinity Podcast',
      description:
        'New episodes every week featuring developers, investors, and innovators building the future.',
      latestEpisodes: 'Latest Episodes',
      listenAnywhere: 'Listen directly on Spotify or your favorite podcast platform',
      openInSpotify: 'Open in Spotify',
      listenCTA: 'Listen',
      loadMore: 'Load More Episodes',
      showLess: 'Show Less Episodes',
      loadingGrid: 'Loading podcast episodes...'
    },
    shorts: {
      title: 'YouTube Shorts / Reels',
      description: 'Quick insights and visual explainers from the field.',
      subscribe: 'Subscribe on YouTube',
      loadMore: 'Load More Shorts',
      showLess: 'Show Less Shorts',
      empty: 'No YouTube Shorts found. Check if YouTube API is working.'
    },
    longform: {
      title: 'Long-form & Whiteboard Videos',
      description: 'Deep dives into frameworks, analysis, and case studies.',
      comingSoon: 'Coming Soon',
      chip: 'Long-form',
      loadMore: 'Load More Videos',
      showLess: 'Show Less Videos',
      discoverMore: 'Discover more in-depth content and detailed explanations',
      emptyTitle: 'No long-form videos found',
      emptyHint: 'Check if your backend API is providing long-form video data'
    },
    articles: {
      title: 'Featured Articles & Interviews',
      description: 'Media appearances and featured stories.',
      readArticle: 'Read Article'
    },
    loading: { message: 'Loading your latest content...' },
    common: {
      loading: 'Loading...',
      more: 'more',
      views: 'views'
    }
  },

  es: {
    hero: {
      badge: 'Centro de Medios',
      title: 'Medios',
      subtitle:
        'Vitrina de contenido en acción. Mira y escucha ideas sobre bienes raíces, capital de riesgo y sostenibilidad.'
    },
    filters: {
      label: 'Filtrar:',
      all: 'Todos',
      podcast: 'Podcast',
      shorts: 'Clips',
      longform: 'Formato largo',
      articles: 'Artículos'
    },
    podcast: {
      title: 'El Podcast Infinity',
      description:
        'Nuevos episodios cada semana con desarrolladores, inversionistas e innovadores que construyen el futuro.',
      latestEpisodes: 'Últimos Episodios',
      listenAnywhere: 'Escucha en Spotify o en tu plataforma favorita',
      openInSpotify: 'Abrir en Spotify',
      listenCTA: 'Escuchar',
      loadMore: 'Cargar más episodios',
      showLess: 'Mostrar menos episodios',
      loadingGrid: 'Cargando episodios del podcast...'
    },
    shorts: {
      title: 'YouTube Shorts / Reels',
      description: 'Ideas rápidas y explicaciones visuales desde el campo.',
      subscribe: 'Suscribirse en YouTube',
      loadMore: 'Cargar más clips',
      showLess: 'Mostrar menos clips',
      empty: 'No se encontraron Shorts de YouTube. Verifica si la API de YouTube está funcionando.'
    },
    longform: {
      title: 'Videos de formato largo y Pizarra',
      description: 'Análisis profundos de marcos, estudios de caso y estrategias.',
      comingSoon: 'Próximamente',
      chip: 'Formato largo',
      loadMore: 'Cargar más videos',
      showLess: 'Mostrar menos videos',
      discoverMore: 'Descubre más contenido detallado y explicaciones en profundidad',
      emptyTitle: 'No se encontraron videos de formato largo',
      emptyHint: 'Verifica si tu API backend está proporcionando datos de formato largo'
    },
    articles: {
      title: 'Artículos e Entrevistas Destacados',
      description: 'Apariciones en medios e historias destacadas.',
      readArticle: 'Leer artículo'
    },
    loading: { message: 'Cargando tu contenido más reciente...' },
    common: {
      loading: 'Cargando...',
      more: 'más',
      views: 'vistas'
    }
  }
},

subscribe: {
  en: {
    hero: {
      badge: 'Newsletter',
      title: 'To Infinity and Beyond',
      subtitle:
        'A weekly letter from Zeus Hernandez on building the future — across real estate, innovation, capital, and regenerative systems.'
    },
    value: {
      whyTitle: 'Why Subscribe?',
      paragraphs: [
        'I write about what it means to design, fund, and scale systems that will shape the next century — starting with real estate, but never ending there.',
        'To Infinity and Beyond is my field journal as a builder: frameworks, observations, and signals from the intersection of capital, climate, design, and technology.',
        "Whether you're an investor, architect, founder, or simply someone who wants to help shape what's next — this is for you."
      ]
    },
    weekly: {
      title: 'What to expect each week:',
      items: [
        {
          id: 'infinite_real_estate',
          title: 'Infinite Real Estate',
          description: 'Essays and frameworks on regenerative development'
        },
        {
          id: 'capital_strategy',
          title: 'Capital Strategy',
          description: 'Notes on AI, capital strategy, and city-building'
        },
        {
          id: 'global_insights',
          title: 'Global Insights',
          description: 'Real-world lessons from Latin America, U.S., and frontier markets'
        },
        {
          id: 'systems_thinking',
          title: 'Systems Thinking',
          description: "What's coming in energy, infrastructure, ventures, and beyond"
        }
      ]
    },
    form: {
      titlePrefix: 'Subscribe to',
      subtitle: 'Join thousands of builders, investors, and innovators',
      embedTitle: 'Substack Embed',
      embedDomain: 'zeushernandez.substack.com',
      emailPlaceholder: 'Enter your email',
      button: 'Subscribe to To Infinity and Beyond',
      noNoise: 'No noise. Just signal.'
    },
    success: {
      title: 'Welcome to the Community!',
      subtitle: "You'll receive weekly insights on building the infinite future."
    },
    testimonials: {
      title: 'What Readers Say',
      subtitle: 'Join a community of forward-thinking professionals',
      items: [
        {
          text:
            "Zeus's insights on regenerative development have fundamentally changed how I approach investment decisions. Essential reading for anyone in real estate.",
          author: 'Maria Rodriguez',
          title: 'Managing Partner, GreenVest Capital'
        },
        {
          text:
            'The intersection of technology and real estate has never been clearer. Zeus bridges theory and practice beautifully.',
          author: 'David Chen',
          title: 'VP of Innovation, Urban Development Corp'
        },
        {
          text:
            "As a founder in PropTech, I rely on Zeus's weekly insights to stay ahead of industry trends and emerging opportunities.",
          author: 'Sarah Kim',
          title: 'CEO, BuildTech Solutions'
        }
      ]
    },
    finalCta: {
      title: 'Ready to think infinitely?',
      subtitle: 'Join the conversation on building the future.',
      button: 'Visit Substack'
    }
  },

  es: {
    hero: {
      badge: 'Boletín',
      title: 'Hacia el Infinito y Más Allá',
      subtitle:
        'Una carta semanal de Zeus Hernández sobre cómo construir el futuro — en bienes raíces, innovación, capital y sistemas regenerativos.'
    },
    value: {
      whyTitle: '¿Por qué suscribirte?',
      paragraphs: [
        'Escribo sobre lo que significa diseñar, financiar y escalar sistemas que darán forma al próximo siglo — comenzando por el sector inmobiliario, pero sin terminar ahí.',
        'Hacia el Infinito y Más Allá es mi diario de campo como constructor: marcos, observaciones y señales en la intersección de capital, clima, diseño y tecnología.',
        'Ya seas inversionista, arquitecto, fundador o simplemente alguien que quiere ayudar a moldear lo que viene — esto es para ti.'
      ]
    },
    weekly: {
      title: 'Qué esperar cada semana:',
      items: [
        {
          id: 'infinite_real_estate',
          title: 'Bienes Raíces Infinitos',
          description: 'Ensayos y marcos sobre desarrollo regenerativo'
        },
        {
          id: 'capital_strategy',
          title: 'Estrategia de Capital',
          description: 'Notas sobre IA, estrategia de capital y construcción de ciudades'
        },
        {
          id: 'global_insights',
          title: 'Perspectivas Globales',
          description: 'Lecciones reales de América Latina, EE. UU. y mercados frontera'
        },
        {
          id: 'systems_thinking',
          title: 'Pensamiento de Sistemas',
          description: 'Lo que viene en energía, infraestructura, emprendimientos y más'
        }
      ]
    },
    form: {
      titlePrefix: 'Suscribirse a',
      subtitle: 'Únete a miles de constructores, inversionistas e innovadores',
      embedTitle: 'Integración de Substack',
      embedDomain: 'zeushernandez.substack.com',
      emailPlaceholder: 'Ingresa tu correo',
      button: 'Suscribirse a Hacia el Infinito y Más Allá',
      noNoise: 'Sin ruido. Solo señal.'
    },
    success: {
      title: '¡Bienvenido a la comunidad!',
      subtitle: 'Recibirás ideas semanales para construir el futuro infinito.'
    },
    freeDownload: {
      title: 'Descarga gratuita',
      subtitle: 'Exclusivo para suscriptores',
      guideTitle: 'Guía “Introducción a los Bienes Raíces Infinitos”',
      description:
        'Un marco integral para entender el desarrollo regenerativo, el despliegue inteligente de capital y el pensamiento infinito en bienes raíces. Perfecto para inversionistas, desarrolladores y quienes se interesan por el futuro del entorno construido.',
      guideAlt: 'Portada del eBook Introducción a los Bienes Raíces Infinitos',
      coverPlaceholder: 'Portada del eBook',
      coverSubtitle: 'Bienes Raíces Infinitos',
      meta: {
        pagesLabel: 'páginas',
        downloadsLabel: 'descargas'
      }
    },
    testimonials: {
      title: 'Lo que dicen los lectores',
      subtitle: 'Únete a una comunidad de profesionales visionarios',
      items: [
        {
          text:
            'Las ideas de Zeus sobre desarrollo regenerativo han cambiado por completo cómo tomo decisiones de inversión. Lectura esencial para cualquiera en inmobiliario.',
          author: 'María Rodríguez',
          title: 'Socia Directora, GreenVest Capital'
        },
        {
          text:
            'La intersección entre tecnología y bienes raíces nunca ha sido más clara. Zeus une teoría y práctica de forma magnífica.',
          author: 'David Chen',
          title: 'VP de Innovación, Urban Development Corp'
        },
        {
          text:
            'Como fundadora en PropTech, confío en las ideas semanales de Zeus para anticipar tendencias y oportunidades emergentes.',
          author: 'Sarah Kim',
          title: 'CEO, BuildTech Solutions'
        }
      ]
    },
    finalCta: {
      title: '¿Listo para pensar en infinito?',
      subtitle: 'Únete a la conversación sobre cómo construir el futuro.',
      button: 'Visitar Substack'
    }
  }
},

contact: {
  en: {
    hero: {
      badge: 'Get in Touch',
      titlePrefix: "Let's build something",
      titleEmphasis: 'Infinite',
      intro:
        "Whether you're interested in speaking, media, investment opportunities, or collaboration — I'd love to hear from you."
    },

    info: {
      title: 'Contact Information',
      subtitle: 'Ready to connect and create',
      items: [
        {
          title: 'Email',
          value: 'hello@zeushernandez.com',
          description: 'Direct line for inquiries'
        },
        {
          title: 'Location',
          value: 'Global Remote',
          description: 'Available worldwide'
        },
        {
          title: 'Response Time',
          value: '24-48 Hours',
          description: 'Quick response guaranteed'
        },
        {
          title: 'Time Zone',
          value: 'PST / GMT-8',
          description: 'California based'
        }
      ]
    },

    connect: {
      title: "Let's Connect",
      bullets: {
        speakingLabel: 'Speaking:',
        speakingText: 'Conferences, podcasts, and panels on real estate innovation',
        mediaLabel: 'Media:',
        mediaText: 'Interviews and features on regenerative development',
        investmentLabel: 'Investment:',
        investmentText: 'Opportunities in sustainable real estate ventures',
        collaborationLabel: 'Collaboration:',
        collaborationText: 'Partnerships on infinite thinking projects'
      }
    },

    form: {
      title: 'Send a Message',
      subtitle: "I'll get back to you within 24-48 hours",
      labels: {
        name: 'Name',
        email: 'Email',
        subject: 'Subject',
        message: 'Message'
      },
      placeholders: {
        name: 'Your full name',
        email: 'your@email.com',
        message:
          'Tell me about your project, idea, or how we might work together...'
      },
      selectPlaceholder: 'Select a topic...',
      subjectOptions: [
        'Speaking Opportunity',
        'Media Interview',
        'Investment Discussion',
        'Collaboration',
        'Other'
      ],
      button: 'Send Message'
    },

    success: {
      title: 'Message Sent!',
      message:
        "Thanks for reaching out. I'll get back to you within 24-48 hours to continue the conversation about building something infinite together."
    },

    cta: {
      title: 'Ready to think infinitely?',
      subtitle: "Let's explore how we can build the future together.",
      button: 'Start Conversation'
    }
  },

  es: {
    hero: {
      badge: 'Ponte en Contacto',
      titlePrefix: 'Construyamos algo',
      titleEmphasis: 'Infinito',
      intro:
        'Si te interesan conferencias, medios, oportunidades de inversión o colaboración — me encantará saber de ti.'
    },

    info: {
      title: 'Información de Contacto',
      subtitle: 'Listo para conectar y crear',
      items: [
        {
          title: 'Correo electrónico',
          value: 'hello@zeushernandez.com',
          description: 'Línea directa para consultas'
        },
        {
          title: 'Ubicación',
          value: 'Remoto Global',
          description: 'Disponible en todo el mundo'
        },
        {
          title: 'Tiempo de respuesta',
          value: '24–48 horas',
          description: 'Respuesta rápida garantizada'
        },
        {
          title: 'Huso horario',
          value: 'PST / GMT-8',
          description: 'Con base en California'
        }
      ]
    },

    connect: {
      title: 'Conectemos',
      bullets: {
        speakingLabel: 'Conferencias:',
        speakingText:
          'Conferencias, pódcasts y paneles sobre innovación inmobiliaria',
        mediaLabel: 'Medios:',
        mediaText:
          'Entrevistas y reportajes sobre desarrollo regenerativo',
        investmentLabel: 'Inversión:',
        investmentText:
          'Oportunidades en emprendimientos inmobiliarios sostenibles',
        collaborationLabel: 'Colaboración:',
        collaborationText:
          'Alianzas en proyectos de pensamiento infinito'
      }
    },

    form: {
      title: 'Enviar Mensaje',
      subtitle: 'Te responderé en un plazo de 24–48 horas',
      labels: {
        name: 'Nombre',
        email: 'Correo',
        subject: 'Asunto',
        message: 'Mensaje'
      },
      placeholders: {
        name: 'Tu nombre completo',
        email: 'tu@correo.com',
        message:
          'Cuéntame sobre tu proyecto, idea o cómo podemos trabajar juntos...'
      },
      selectPlaceholder: 'Selecciona un tema...',
      subjectOptions: [
        'Oportunidad de Ponencia',
        'Entrevista en Medios',
        'Discusión de Inversión',
        'Colaboración',
        'Otro'
      ],
      button: 'Enviar Mensaje'
    },

    success: {
      title: '¡Mensaje Enviado!',
      message:
        'Gracias por escribir. Te responderé en 24–48 horas para continuar la conversación sobre cómo construir algo infinito juntos.'
    },

    cta: {
      title: '¿Listo para pensar en infinito?',
      subtitle: 'Exploremos cómo podemos construir el futuro juntos.',
      button: 'Iniciar Conversación'
    }
  }
},

footer: {
  en: {
    brand: {
      tagline:
        'Building the future through sustainable design, intelligent ventures, and infinite thinking.',
      contact: 'Get in touch',
      studio: 'Digital Studio'
    },
    links: {
      title: 'Navigate',
      home: 'Home',
      about: 'About',
      infinity: 'Infinity',
      writings: 'Writings',
      media: 'Media',
      subscribe: 'Subscribe',
      contact: 'Contact'
    },
    social: {
      title: 'Connect'
    },
    bottom: {
      rights: 'All rights reserved.',
      madeWith: 'Made with',
      infinite: 'and infinite thinking',
      craftedBy: 'Crafted by'
    },
    cookies: {
      message:
        'We use cookies to enhance your browsing experience and analyze site traffic. By continuing to use this site, you consent to our use of cookies.',
      accept: 'Accept',
      decline: 'Decline'
    }
  },

  es: {
    brand: {
      tagline:
        'Construyendo el futuro a través del diseño SOSTENIBLE, emprendimientos inteligentes y pensamiento infinito.',
      contact: 'Ponte en contacto',
      studio: 'Estudio Digital'
    },
    links: {
      title: 'Navegar',
      home: 'Inicio',
      about: 'Acerca de',
      infinity: 'Infinity',
      writings: 'Escritos',
      media: 'Medios',
      subscribe: 'Suscribirse',
      contact: 'Contacto'
    },
    social: {
      title: 'Conectar'
    },
    bottom: {
      rights: 'Todos los derechos reservados.',
      madeWith: 'Hecho con',
      infinite: 'y pensamiento infinito',
      craftedBy: 'Creado por'
    },
    cookies: {
      message:
        'Usamos cookies para mejorar tu experiencia de navegación y analizar el tráfico del sitio. Al continuar usando este sitio, aceptas nuestro uso de cookies.',
      accept: 'Aceptar',
      decline: 'Rechazar'
    }
  }
},

nav: {
  en: {
    links: {
      home: 'Home',
      about: 'About',
      infinity: 'Infinity',
      writings: 'Writings',
      media: 'Media',
      subscribe: 'Subscribe',
      contact: 'Contact'
    },
    tagline: 'Building the infinite future'
  },
  es: {
    links: {
      home: 'Inicio',
      about: 'Acerca de',
      infinity: 'Infinity',
      writings: 'Escritos',
      media: 'Medios',
      subscribe: 'Suscribirse',
      contact: 'Contacto'
    },
    tagline: 'Construyendo el futuro infinito'
  }
},




  // ===================== COMMON/SHARED =====================
  common: {
    en: {
      loading: "Loading...",
      error: "Error",
      retry: "Retry",
      close: "Close",
      next: "Next",
      previous: "Previous",
      readMore: "Read More",
      watchNow: "Watch Now",
      listenNow: "Listen Now"
    },
    es: {
      loading: "Cargando...",
      error: "Error",
      retry: "Reintentar",
      close: "Cerrar",
      next: "Siguiente",
      previous: "Anterior",
      readMore: "Leer Más",
      watchNow: "Ver Ahora",
      listenNow: "Escuchar Ahora"
    }
  }

  // ===================== ADD MORE SECTIONS AS NEEDED =====================
  // You can add sections for: writings, media, subscribe, contact, etc.
};

// Helper function to get translations for a specific section and language
export const getTranslations = (section, language = 'en') => {
  return translations[section]?.[language] || translations[section]?.en || {};
};

// Helper function to get a specific translation
export const t = (section, key, language = 'en') => {
  const sectionTranslations = getTranslations(section, language);
  return sectionTranslations[key] || translations[section]?.en?.[key] || key;
};